import { MSG91_CHAT_WIDGET_URL } from "constants/global";
import { loadScript } from "./helpers";

const WIDGET_READY_DELAY_MS = 500;

let scriptLoaded = false;
let scriptLoading: Promise<boolean> | null = null;
let widgetReady = false;
let pendingOpen = false;

export const isMsg91ChatReady = (): boolean => widgetReady && !!window.chatWidget;

export const setMsg91WidgetReady = (ready: boolean): void => {
    widgetReady = ready;
};

export const loadMsg91ChatScript = async (): Promise<boolean> => {
    if (scriptLoaded) return true;
    if (!scriptLoading) {
        scriptLoading = loadScript(MSG91_CHAT_WIDGET_URL).then((loaded) => {
            scriptLoaded = loaded;
            return loaded;
        });
    }
    return scriptLoading;
};

export const initMsg91ChatWidget = (config: Msg91HelloConfig, delayMs = 0): void => {
    initChatWidget(config, delayMs);
};

export const hideMsg91ChatWidget = (): void => {
    window.chatWidget?.hide();
};

export const openMsg91Chat = (): void => {
    if (isMsg91ChatReady()) {
        window.chatWidget?.open();
        return;
    }
    pendingOpen = true;
};

export const toggleMsg91Chat = (): void => {
    window.chatWidget?.toggleWidget();
};

const consumePendingOpen = (): void => {
    if (!pendingOpen) return;
    pendingOpen = false;
    window.chatWidget?.open();
};

export const finalizeMsg91WidgetInit = (): void => {
    window.setTimeout(() => {
        hideMsg91ChatWidget();
        setMsg91WidgetReady(true);
        consumePendingOpen();
    }, WIDGET_READY_DELAY_MS);
};
